import axios from "axios";
import { handleAPIError, handleAPISuccess } from "./utils/utilsAPI";
import { createTransactionValidation, getTransactionByOwnerIdValidation, tokenAndIdValidation, typeAndIdValidation } from "./utils/validateAPI";

import { BASE_URL } from "./constant";
import store from "../store";
import { successToast } from "../store/dbFilter/actions";

const token = "8lQzN922rpRDaMbh3m5J";

const apiTransaction = axios.create({
  baseURL: `${BASE_URL}/transactions`,
});

/**
 * validates the argument received and Makes an API call to create or update the transaction
 * @param {object} transactionDetail - contains all the data required to create a transaction
 * @returns {Promise} - Resolves when the promise returns transaction details  or logs in case of failure.
 */
const createTransaction = async (transactionDetail) => {
  const payload = { token: token, ...transactionDetail };
  try {
    await createTransactionValidation.validate(payload);
    const res = await apiTransaction.post(`/`, payload);
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the transaction
 * @param {string} id - id of the transaction to get the particular transaction details or "all" to get all the transaction
 * @param {string} type - type of the transaction to get the particular transaction details or "*" to get all the transaction
 * @returns {Promise} - Resolves when the promise returns all the transaction or empty array in case of no transaction or logs in case of failure.
 */
const getTransaction = async (id = "all", type = "*") => {
  const payload = {
    token: token,
    type: type,
    id: id,
  };
  try {
    await typeAndIdValidation.validate(payload);
    const res = await apiTransaction.get(`/`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the recent logs
 * @param {string} id - id of the transaction to fetch the recent logs
 * @returns {Promise} - Resolves when the promise returns  transaction or logs in case of failure.
 */
const getRecentTransaction = async (id) => {
  const payload = {
    token: token,
    id: id,
  };
  try {
    await tokenAndIdValidation.validate(payload);
    const res = await apiTransaction.get(`/recent`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the transaction by user Id.
 * @param {string} userId - id of the user to fetch all the transaction under them.
 * @returns {Promise} - Resolves when the promise returns all the transaction or logs in case of failure.
 */
const getTransactionByUserId = async (id) => {
  const payload = { token: token, id: id };
  try {
    await tokenAndIdValidation.validate(payload);
    const res = await apiTransaction.get(`/byUserId`, { params: payload });
    return handleAPISuccess(res);
  } catch (err) {
    console.log("API call failed: ", err);
    handleAPIError(err); // Call error handler
    throw err;
  }
};

/**
 * validates the argument received and Makes an API call to get the transaction by owner Id.
 * @param {string} ownerId - id of the owner to fetch all the transaction under them.
 * @returns {Promise} - Resolves when the promise returns all the transaction or logs in case of failure.
 */
const getTransactionByOwnerId = async (data) => {
  const payload = { token: token, ...data };
  try {
    await getTransactionByOwnerIdValidation.validate(payload);
    const res = await apiTransaction.get(`/byOwnerId`, { params: payload });
    // return res;
    const {  data } = handleAPISuccess(res);
    const { allTransactions } = data;

    if (allTransactions?.length === 0) {
      console.log("No transaction details");
      store.dispatch(successToast({ title: "Success", message: "No transaction details available" }));
    }
    return allTransactions;
  } catch (err) {
    console.log(" Error: ", err);
    handleAPIError(err);
    throw err;
  }
};

export { createTransaction, getTransaction, getRecentTransaction, getTransactionByUserId, getTransactionByOwnerId };
